import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Link,
} from '@material-ui/core'
import FileCopyTwoToneIcon from '@material-ui/icons/FileCopyTwoTone'
import ExpandCollapseBox from 'Components/ExpandCollapseBox'
import { ButtonInline } from 'Components/Buttons/ButtonInline'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import EditIcon from 'Assets/Images/icons/edit'
import { handleConfirmationDialog } from '../../../../../City/Page/Ambasadors/EmailPipelineView/utils'
import { ConfirmDialogV2 } from '../../../../../../Components/ConfirmDialogV2/ConfirmDialogV2.jsx'
import {
  StatesRegions,
  PrintersLabels,
} from '../../../../../../shared/constants'
import { DeleteIcon } from '../../../../../../Assets/Images/icons/DeleteIconV2.js'
import { deletePrinter } from '../../../../../../Module/graphQL/index.js'
import { EditIcon as EditIconV2 } from '../../../../../../Assets/Images/icons/editIcon.jsx'
import { PrintersModal } from './PrintersModal'

import styles from './styles.js'

const useStyles = makeStyles(() => styles)

export const PrintersTable = ({
  countryId,
  printersData,
  isEditingTable,
  statesData,
  refetch,
  visible,
}) => {
  const classes = useStyles()
  const headers = ['name', 'availableStates', 'region', 'actions']
  const [printers, setPrinters] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [printerToEdit, setPrinterToEdit] = useState(null)
  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })

  useEffect(() => {
    if (
      printersData &&
      printersData.length &&
      statesData &&
      statesData.length
    ) {
      setPrinters(
        printersData.map(printer => {
          const availableStates = printer.availableStates
            .map(
              s =>
                statesData.find(state => String(state.id) === String(s)).code,
            )
            .join(', ')
          const region = [
            ...new Set(
              printer.availableStates.map(
                stateId =>
                  StatesRegions[
                    statesData
                      .find(s => String(s.id) == String(stateId))
                      .region.toLowerCase()
                  ],
              ),
            ),
          ].join(', ')

          return {
            availableStates,
            region,
            name: printer.name,
            actions: (
              <div className={classes.actionsContainer}>
                <EditIconV2
                  onClick={() => handleShowModal(printer)}
                  className={classes.actionButton}
                />
                <DeleteIcon
                  className={classes.actionButton}
                  onClick={() => handlePrinterDelete(printer)}
                />
              </div>
            ),
          }
        }),
      )
    }
  }, [printersData, statesData])

  const handlePrinterDelete = printer => {
    handleConfirmationDialog({
      title: `Delete ${printer.name} printer`,
      contentText: (
        <span cypress_id={'modalBody'}>
          Are you sure you want to delete the <b>{printer.name}</b> printer ?
        </span>
      ),
      setConfirmDialogData,
      hasOptions: true,
      rightButtonLable: 'Yes',
      leftButtonLable: 'No',
      onConfirm: async () => {
        await deletePrinter(printer.id)
        refetch()
      },
    })
  }

  const renderHeaders = () => {
    return headers.map((header, index) => (
      <TableCell
        key={header}
        colSpan={1}
        align={index === 0 ? 'left' : 'center'}
        className={classes.borderRight}
      >
        <Typography>{PrintersLabels[header]}</Typography>
      </TableCell>
    ))
  }

  const handleShowModal = printer => {
    if (isEditingTable) {
      return
    }

    setPrinterToEdit(printer)
    setShowModal(true)
  }

  return visible ? (
    <Box>
      <ExpandCollapseBox title={'Printers Matrix'}>
        <Box display={'flex'} justifyContent={'flex-end'}>
          {printers.length ? (
            <ButtonInline
              className={classes.uploadBtn}
              label={'Add new printer'}
              icon={<EditIcon style={{ marginLeft: '7px' }} />}
              labelFirst
              onClickHandler={() => handleShowModal(null)}
            />
          ) : null}
        </Box>
        {printers.length ? (
          <Box display="flex" flexDirection="column" alignItems="end">
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead className={classes.tableHead}>
                  <TableRow>{renderHeaders()}</TableRow>
                </TableHead>
                <TableBody>
                  {printers.map(row => {
                    return (
                      <TableRow hover tabIndex={-1} key={row['FLYERS_COUNT']}>
                        {headers.map((column, index) => {
                          const value = row[column]
                          return (
                            <TableCell
                              key={column}
                              align={index === 0 ? 'left' : 'center'}
                              className={classes.borderRight}
                            >
                              <Typography>{value}</Typography>
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <Box className={classes.noDataWrapper}>
            <Box className={classes.noData}>
              <Typography>No Data</Typography>
              <FileCopyTwoToneIcon color="#8A96A0" />
            </Box>
            <Link
              component="span"
              variant="body2"
              onClick={() => handleShowModal(null)}
            >
              Add a printer
            </Link>
          </Box>
        )}
      </ExpandCollapseBox>
      <Modal
        show={showModal}
        onEscapeKeyDown={() => {
          setShowModal(false)
          setPrinterToEdit(null)
        }}
        className={classes.printersModal}
      >
        <PrintersModal
          setShowModal={setShowModal}
          statesData={statesData}
          printer={printerToEdit}
          countryId={countryId}
          refetch={refetch}
        />
      </Modal>
      <Modal
        show={confirmDialogData.isOpen}
        onEscapeKeyDown={() => setConfirmDialogData({ isOpen: false })}
      >
        <ModalBody>
          {confirmDialogData.isOpen && (
            <ConfirmDialogV2
              {...confirmDialogData}
              className={classes.deleteModal}
            />
          )}
        </ModalBody>
      </Modal>
    </Box>
  ) : null
}
